export default __webpack_public_path__ + "static/media/ali-ashraf.fac0cf5d.png";